import React from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./stopFormPlay.data.form";
import InputTextarea from "../../../utils/InputTextarea";

const StopForm = (props) => {
  const { t } = useTranslation();
  const { handleSubmit, cancelAction, play } = props;

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <h3 className="title">
            {play
              ? t(`forms.stopHistory.dialog.play.title`)
              : t(`forms.stopHistory.dialog.pause.title`)}
          </h3>
        </div>
      </div>
      <div className="row justify-content-center ">
        <div className="col-12 col-md-11 marg-btm-1rem">
          <p>
            {play
              ? t(`forms.stopHistory.dialog.play.text`)
              : t(`forms.stopHistory.dialog.pause.text`)}
          </p>
        </div>
      </div>
      <div className="row justify-content-center ">
        <div className="col-12 col-md-11">
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="row">
              <div className="col-12 mt-2">
                <Field
                  id="comment"
                  className="form-control"
                  labelField={t("forms.stopHistory.labels.comment")}
                  name="comment"
                  component={InputTextarea}
                  fieldType="text"
                  placeholder=""
                  mandatory
                />
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                <button
                  type="button"
                  onClick={() => cancelAction()}
                  className="btn btn-lg btn-secondary me-2"
                >
                  {play
                    ? t(`forms.stopHistory.dialog.play.buttonNo`)
                    : t(`forms.stopHistory.dialog.pause.buttonNo`)}
                </button>
                <button type="submit" className="btn btn-lg btn-primary">
                  {play
                    ? t(`forms.stopHistory.dialog.play.buttonOk`)
                    : t(`forms.stopHistory.dialog.pause.buttonOk`)}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

StopForm.propTypes = {
  handleSubmit: PropTypes.func,
  cancelAction: PropTypes.func,
};

const StopFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "StopForm",
})(StopForm);

export default StopFormF;
